import { Container } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppBar from './AppBar';

export default function LayoutPartial() {
    return (
        <>
            <AppBar />
            <Container maxWidth='lg'>
                <Outlet />
            </Container>
        </>
    )
}